<template>
    <div class="com-header my-header flex">
        <div class="h-left flex1">

        </div>
        <div v-if="!showText" class="h-center">
			<img :class="imgUrl ? 'img-1' : ''" :src="imgUrl" alt="">
        </div>
        <div v-else class="h-center">
			{{ title }}
        </div>
        <div class="h-right flex1">
            <!-- {{ nowWeek }} -->
            <!-- <span class="time">{{ nowDate }}&nbsp;&nbsp;&nbsp;&nbsp;{{ nowTime }}</span> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            // default: '协鑫智算（苏州）中心'
        },
        showText: {
            type: Boolean,
            default: false
        },
        imgUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
			nowDate: "", // 当前日期
			nowTime: "", // 当前时间
			nowWeek: "", // 当前星期
        }
    },
    mounted() {
        // 时间
        this.getDate()
        if(!this.imgUrl) {
            if(location.href.indexOf('digitalfactory-home') > -1) {
                this.imgUrl = require('@/assets/images/exposition/header/header3.png')
            } else if(location.href.indexOf('xunidianchang') > -1) {
                this.imgUrl = require('@/assets/images/exposition/header/header4.png')
            } else {
                this.imgUrl = require('@/assets/images/exposition/header/header1.png')
            }
        }
    },
    methods: {
        // 时间
		getDate: function() {
		    let _this = this
			let yy = new Date().getFullYear()
			let mm = new Date().getMonth() + 1
			let dd = new Date().getDate()
			let week = new Date().getDay()
			let hh = `${(new Date().getHours() < 10 ? '0' : '') + new Date().getHours()}`
			let mf = `${(new Date().getMinutes() < 10 ? "0" : '') + new Date().getMinutes()}`
			if (week == 1) {
				this.nowWeek = "星期一";
			} else if (week == 2) {
				this.nowWeek = "星期二";
			} else if (week == 3) {
				this.nowWeek = "星期三";
			} else if (week == 4) {
				this.nowWeek = "星期四";
			} else if (week == 5) {
				this.nowWeek = "星期五";
			} else if (week == 6) {
				this.nowWeek = "星期六";
			} else {
				this.nowWeek = "星期日";
			}
			_this.nowTime = `${hh > 12 ? '下午' : '上午'}` + hh + ":" + mf;
			_this.nowDate = yy + "年" + mm + "月" + dd + "日";
			// _this.nowDate = yy + "-" + mm + "-" + dd + "-";
		},
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.my-header {
    // background: url(~@/assets/images/myComm/header-1.png) no-repeat;
    background-size: 100%;
    position: relative;
    &::before {
        position: absolute;
        background: url(~@/assets/images/myComm/header-bg.png) no-repeat;
        background-size: 100%;
        content: '';
        width: 100%;
        height: 100%;
    }
    > div {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 36px;
        box-sizing: border-box;
        font-size: $FontSize30;
        position: relative;
        box-sizing: border-box;
    }
    .h-left, .h-right {
        padding-bottom: 130px;
    }
    .h-right {
        padding-right: 500px;
        .time{
            position: absolute;
            right: 115px;
            top: 55px;
            @include ffamily-DS;
            font-size: 30px;
        }
    }
    .h-left {
        padding-left: 500px;
    }
    .h-center {
        width: 1590px;
        font-size: 100px;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        .img-1 {
            width: 80%;
        }
    }
}
</style>